var exports = {
  "F": "pageNavigator-RlczY",
  "q": "indicator-RlczY",
};

module.exports = exports;
